import api from '../../services/api'

export default {
  state: {
    products: []
  },
  getters: {
    products(state) {
      return state.products
    }
  },
  mutations: {
    setProducts(state, products) {
      state.products = products
    },
    createProduct(state, product) {
      state.products.push(product)
    },
    updateProduct(state, product) {
      state.products = state.products.map(p =>
        p.id === product.id ? product : p
      )
    },
    removeProduct(state, productId) {
      state.products = state.products.filter(
        product => product.id !== productId
      )
    },
    clearProducts(state) {
      state.products = []
    }
  },
  actions: {
    fetchProducts({ commit }) {
      commit('clearError')
      commit('setLoading', true)
      commit('clearProducts')

      return new Promise((resolve, reject) => {
        api
          .get('products/')
          .then(result => {
            commit('setProducts', result.data)
            resolve(result.data)
          })
          .catch(err => {
            commit('setError', err.response || err)
            try {
              reject(err.response.data.error)
            } catch (e) {
              reject(err)
            }
          })
          .finally(() => commit('setLoading', false))
      })
    },
    createProduct({ commit, rootGetters }, product) {
      commit('clearError')
      commit('setLoading', true)

      const newProduct = {
        description: product.description,
        model: product.model,
        register: {
          token: product.register.token
        },
        city_id: product.city_id,
        user_id: product.user_id,
        role: product.role,
        isBrasil: product.isBrasil
      }

      return new Promise((resolve, reject) => {
        api
          .post('products/', newProduct)
          .then(result => {
            // if (newProduct.user_id === rootGetters.session.user.id) {
            //   // Added validation because when creating user the result object has no instance of the user object,
            //   // which is needed on the ProductsUsersDialog screen
            //   const product = result.data
            //   product.user = {}
            //   product.user.id = result.data.user_id
            //   commit('createProduct', result.data)
            // }
            commit('createProduct', result.data)
            resolve(result.data)
          })
          .catch(err => {
            commit('setError', err.response || err)
            try {
              // Be careful with that
              reject(err.response.data.error)
            } catch (e) {
              reject(err)
            }
          })
          .finally(() => commit('setLoading', false))
      })
    },
    updateProduct({ commit }, updatedProduct) {
      commit('clearError')
      commit('setLoading', true)

      return new Promise((resolve, reject) => {
        api
          .put(`products/${updatedProduct.id}`, updatedProduct)
          .then(result => {
            commit('updateProduct', result.data)
            resolve(result.data)
          })
          .catch(err => {
            commit('setError', err.response || err)
            try {
              reject(err.response.error)
            } catch (e) {
              reject(err)
            }
          })
          .finally(() => commit('setLoading', false))
      })
    },
    removeProduct({ commit }, productId) {
      commit('clearError')
      commit('setLoading', true)

      return new Promise((resolve, reject) => {
        api
          .delete(`products/${productId}`)
          .then(result => {
            commit('removeProduct', productId)
            resolve(result.data)
          })
          .catch(err => {
            commit('setError', err.response || err)
            try {
              reject(err.response.data.error)
            } catch (e) {
              reject(err)
            }
          })
          .finally(() => commit('setLoading', false))
      })
    },
    clearProducts({ commit }) {
      commit('clearProducts')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/product/index.js